import { Component, Input } from '@angular/core';
import { Invoice } from '~gc/domains/invoices/invoice/invoice.model';
import { User } from '~gc/domains/users';
import { Company } from '~gc/domains/users/companies/company.model';
import { DetailedWorkOrder } from '../../../domains/work/models/detailed-work-order';

@Component({
  selector: 'gc-invoice-header',
  templateUrl: './invoice-header.component.html',
  styleUrls: ['./invoice-header.component.scss'],
})
export class InvoiceHeaderComponent {
  @Input() workOrder?: DetailedWorkOrder;
  @Input() reportsProgress?: boolean;
  @Input() invoice!: Invoice;
  @Input() invoiceNumberLabel: string = 'Invoice No.';
  @Input() company?: Company;
  @Input() installer!: User;
  @Input() currentRole?: string;
  @Input() date: Date = new Date();

  /** TT-210: a company paying an installer should see that their COI has lapsed. */
  get coiExpired(): boolean {
    const expiration = (this.installer as { insuranceExpiration?: string | Date | null } | undefined)
      ?.insuranceExpiration;
    return !!expiration && new Date(expiration).getTime() < Date.now();
  }
}
